import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=6b59116c&scoped=true"
import script from "./Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=6b59116c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b59116c",
  null
  
)

export default component.exports